import { useQuery } from "@tanstack/react-query";
import { useCurrentOrganization } from "@/modules/organizations/hooks/use-organizations";
import { getAiUsageSummary, getAiUsageEvents } from "../infrastructure/wallet.api";

export function useAiUsageSummary(from?: string, to?: string) {
  const org = useCurrentOrganization();

  return useQuery({
    queryKey: ["wallet", "ai-usage", "summary", org?.id, from, to],
    queryFn: () => getAiUsageSummary(org!.id, from, to),
    enabled: !!org?.id,
  });
}

export function useAiUsageEvents(page = 1, pageSize = 20, from?: string, to?: string) {
  const org = useCurrentOrganization();

  return useQuery({
    queryKey: ["wallet", "ai-usage", "events", org?.id, page, pageSize, from, to],
    queryFn: () => getAiUsageEvents(org!.id, page, pageSize, from, to),
    enabled: !!org?.id,
  });
}
